import { createColumn, defaultColumns, inputTextField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Name',
    field: 'name',
    component: inputTextField({ req: true, max: 255 })
  })
].concat(defaultColumns)
